import Fetch, { fetchConfig } from '@/hooks/fetch';
import actions from '../constants';

export default {
  useFetchRequestMarkdown: ({ category, code }, readStatus) => Fetch.useFetchDispatch(
    actions.FETCH_REQUEST_MARKDOWN,
    readStatus,
    { category, code },
    fetchConfig([category, code, readStatus]),
  ),
};
